import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import htmlTemplate from 'properties/main/html-text-alignment.ejs';


class MainHtmlView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = htmlTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'change input[type=checkbox]' : 'updateCheckAttributes',
            'click img' : 'updateAttributes'
        };

        // Add needed property
        if (!this.model.get('isHtml')) {
            this.model.set('isHtml', 'unchecked', {silent: true});
        }
        if (!this.model.get('textAlignment')) {
            this.model.set('textAlignment', 'left', {silent:true});
            this.model.set('alignLeftSelection', this.selectedColor, {silent:true});
            this.model.set('alignCenterSelection', this.unselectedColor, {silent:true});
            this.model.set('alignRightSelection', this.unselectedColor, {silent:true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        var newValue = "";
        if (propVal) {
            newValue = "checked";
        }
        this.model.set( propName, newValue );
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        //const propVal  = ev.currentTarget.value;
        var newValue = "left";
        this.model.set('alignLeftSelection', this.unselectedColor, {silent:true});
        this.model.set('alignCenterSelection', this.unselectedColor, {silent:true});
        this.model.set('alignRightSelection', this.unselectedColor, {silent:true});
        if (propName === "align-center") {
            newValue = "center";
            this.model.set('alignCenterSelection', this.selectedColor, {silent:true});
        } else if (propName === "align-right") {
            newValue = "right";
            this.model.set('alignRightSelection', this.selectedColor, {silent:true});
        }
        else {
            this.model.set('alignLeftSelection', this.selectedColor, {silent:true});
        }
        this.model.set( 'textAlignment', newValue );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        return this;
    }

}

export default MainHtmlView;
